// Playable races. Each has a fixed colour + one small passive (v1 passives are
// flavour text for now; their effects land with the economy/combat phases).

export interface RaceDef {
  key: string;
  name: string;
  color: number;
  colorName: string; // plain-language banner colour, so the player always knows which side is theirs
  homeland: string; // proper name of this race's home island (shown on the map + as an overview group header)
  passive: string;
  // The two resources (indices into Gold/Wood/Stone/Food) this race trains its BASE units (Warrior,
  // Spearman) from, its army is funded by a signature pair, so every race feels distinct and no two mass
  // troops from the same goods. A faction's HOME island is set to produce this pair (engine.createGame),
  // guaranteeing it can always field basic troops; Gold-using races can also afford research from home.
  unitRes: readonly [number, number];
  // The extra resource its tech-UNLOCKED units (Archer, Rider) additionally demand: a "new thing" beyond
  // the base pair, distinct per race (usually one it does NOT natively produce, so elite armies push you to
  // trade or conquer for it). Base units never need it. See engine.unitCost.
  advancedRes: number;
}

// Resource indices: Gold 0, Wood 1, Stone 2, Food 3 (see types.RES_NAME).
export const RACES: RaceDef[] = [
  { key: 'orc', name: 'Orcs', color: 0xd23b3b, colorName: 'Red', homeland: 'Grimskar', passive: '+Combat: units hit harder', unitRes: [1, 2], advancedRes: 3 }, // base Wood+Stone; elites also need Food (war-feasts)
  { key: 'elf', name: 'Elves', color: 0x3fb950, colorName: 'Green', homeland: 'Silvergrove', passive: '+Research: tech comes faster', unitRes: [0, 1], advancedRes: 2 }, // base Gold+Wood; elites also need Stone (arrowheads)
  { key: 'dwarf', name: 'Dwarves', color: 0xe3b23c, colorName: 'Gold', homeland: 'Stonehearth', passive: '+Mining: more Stone & Gold', unitRes: [0, 2], advancedRes: 1 }, // base Gold+Stone; elites also need Wood (war machines)
  { key: 'human', name: 'Humans', color: 0x4d8fd6, colorName: 'Blue', homeland: 'Highmarch', passive: '+Economy: more Gold', unitRes: [0, 3], advancedRes: 2 }, // base Gold+Food; elites also need Stone (armories)
  { key: 'undead', name: 'Undead', color: 0x9b6dc0, colorName: 'Violet', homeland: 'Mordhollow', passive: 'Cheaper units', unitRes: [2, 3], advancedRes: 1 }, // base Stone+Food; elites also need Wood (siege bones)
];
